<template>
  <div class="milepost-dialog-wrap" v-loading="loading">
    <el-dialog
      class="milepost-dialog"
      :visible.sync="dialogShow"
      destroy-on-close
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="milepost-dialog-top">
        <p class="tit">{{ id ? '里程碑' : '新建里程碑' }}</p>
        <div class="icon-wrap">
          <el-dropdown v-if="id && !readonly" placement="bottom-start" @command="handleCommand" trigger="click">
            <span class="el-dropdown-link">
              <i class="icon iconfont iconicon_more_task1 activeIconHover"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="milepost-dialog-dropdown">
              <el-dropdown-item>
                <i class="icon iconfont iconicon_delete"></i>
                删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <i class="icon iconfont iconicon_close1 activeIconHover" @click="handleClose"></i>
        </div>
      </div>

      <div class="milepost-dialog-con" :class="{'edit-con': id}">
        <div class="con-tit">
          <el-checkbox v-show="id && updateMilestoneStatus" v-model="milepostStatus" @change="handleChangeStatus"></el-checkbox>

          <el-input
            ref="milepostNameShow"
            v-show="milepostNameShow || (!id && !form.milestone_name)"
            v-model="form.milestone_name"
            placeholder="请输入标题"
            clearable
            @change="handleChange($event, 'milestone_name')"
            @focus="handleInputFocus"
            @blur="handleBlur('milepostNameShow')"
          ></el-input>
          <p
            v-show="!milepostNameShow || (form.milestone_name && !id)"
            @click="handleAddMilepost('milepostNameShow')"
            :class="{'complete': form.milestone_status === 1, 'readonly': readonly}"
          >{{ form.milestone_name }}</p>
        </div>

        <div class="con-item">
          <div class="item-label">
            <i class="icon iconfont iconicon_time1"></i>
            <p>完成日期</p>
          </div>
          <div class="item-msg">
            <div
              class="item-msg-text"
              @click="handleAddMilepost('milepostDateShow')"
              v-show="!milepostDateShow"
            >
              <div class="item-msg-con item-date" :class="{'readonly': readonly}" v-if="form.end_date">
                {{ form.end_date }}
                <i
                  v-if="!readonly"
                  @click.stop="handleClearDate"
                  class="el-input__icon el-icon-circle-close el-input__clear"
                ></i>
                <!-- {{ id ? form.end_date : form.end_date.getTime() / 1000 | formatDate }} -->
              </div>
              <span
                v-else
                class="add"
              >添加</span>
            </div>
            <el-date-picker
              ref="milepostDateShow"
              v-show="milepostDateShow"
              v-model="form.end_date"
              value-format="yyyy/MM/dd"
              type="date"
              placeholder="选择日期"
              @change="handleChange($event, 'end_date')"
              @blur="handleBlur('milepostDateShow')"
            ></el-date-picker>
          </div>
        </div>
        <div class="con-item">
          <div class="item-label">
            <i class="icon iconfont iconicon_text"></i>
            <p>描述</p>
          </div>
          <div class="item-msg">
            <div
              class="item-msg-text"
              @click="handleAddMilepost('milepostDescShow')"
              v-show="!milepostDescShow"
            >
              <div class="desc-wrap" v-show="form.description">
                <p ref="desc" class="item-msg-con" :class="{'readonly': readonly}">
                  {{ form.description }}
                </p>
                <span class="check-more" :class="{ descfold }" v-if="descShowMore" @click.stop="handleDesc">
                  {{ descfold ? '收起' : '查看更多'}}
                  <i class="icon iconfont" :class="descfold ? 'iconicon_arrow_task2' : 'iconicon_arrow_task'"></i>
                </span>
              </div>
              <span
                v-show="!form.description && !readonly"
                class="add"
              >添加</span>
              <span class="no-content-readonly" v-if="!form.description && readonly">
                暂无
              </span>
            </div>
            <el-input
              ref="milepostDescShow"
              v-show="milepostDescShow"
              v-model="form.description"
              maxlength="1000"
              type="textarea"
              clearable
              @blur="handleBlur('milepostDescShow')"
            ></el-input>
          </div>
        </div>
        <div class="con-item">
          <div class="item-label">
            <i class="icon iconfont iconicon_annex2"></i>
            <p>附件</p>
          </div>
          <div class="item-msg">
            <!-- <span class="add" @click="handleAddMilepost('milepostFileShow')">添加</span> -->
            <Attachement
              v-if="msgFinish"
              :config="config"
              :readonly="readonly"
              :isCrossProject="true"
              v-model="form.attachments"
              :defaultValue="form.attachments"
              @change="saveData"
            ></Attachement>
          </div>
        </div>
      </div>

      <div class="btn-wrap" v-if="!id">
        <span class="cancel text-btn-active" @click="handleClose">取消</span>
        <!-- <wf-button plain @click="handleClose">取消</wf-button> -->
        <wf-button type="primary" @click="handleAdd">
          确定
        </wf-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//组件
import ToolTip from '@/components/toolTip'
import Attachement from './Attachment/Attachment/index'
//api
import api from '@/services/api/home/home'

export default  {
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    id: { // 里程碑ID
      type: Number,
      default: null
    },
    crossPojectId: {
      type: Number,
      default: null
    },
    readonly: { // 只读，没有更改里程碑的权限
      type: Boolean,
      default: false
    },
    updateMilestoneStatus: { // 更新里程碑状态的权限
      type: Boolean,
      default: false
    }
  },
  components: {
    ToolTip,
    Attachement
  },
  data() {
    return {
      loading: false,
      msgFinish: false,
      descShowMore: false, //描述那里是否展示更多
      descfold: false, //描述是否变成需要收起
      form: {
        milestone_name: '',
        end_date: '',
        description: '',
        attachments: []
      },
      milestone_name: '',
      end_date: '',
      config: {
        file_ext: ['jpg', 'png', 'doc', 'docx', 'pdf', 'rar', 'zip'],
        file_size: 10485760
      },
      milepostNameShow: false,
      milepostStatus: false,
      milepostDateShow: false,
      milepostDescShow: false,
      milepostFileShow: false,
    }
  },
  watch: {
    dialogShow(val) {
      this.msgFinish = false
      this.form = {
        milestone_name: '',
        end_date: '',
        description: '',
        attachments: []
      }
      if (val) {
        this.milepostNameShow = false
        if (this.id) {
          //编辑修改
          this.getMilepostInit()
        } else {
          this.msgFinish = true
        }
      }
    }
  },
  methods: {
    async getMilepostInit() {
      this.loading = true
      const res = await api.checkCrossProjectMilepost({ id: this.id })
      if (res) {
        this.form = res
        this.form.end_date = this.form.end_date.replaceAll('-', '/')
        this.milepostStatus = this.form.milestone_status ? true : false

        this.milestone_name = this.form.milestone_name
        this.end_date = this.form.end_date

        this.$nextTick(() => {
          this.descHandle() //判断描述字数是否超出范围
        })

        this.loading = false

        this.msgFinish = true
      }
    },
    //清除时间
    handleClearDate() {
      this.form.end_date = ''
      if (this.id) {
        this.handleAdd()
      }
    },
    descHandle() {
      const _height = this.$refs.desc.clientHeight
      // console.log('描述元素的高度:' + _height)
      if (_height > 110) {
        this.$refs.desc.className += ' over'
        this.descShowMore = true
        this.descfold = false
      } else {
        this.descShowMore = false
      }
      // console.log(this.$refs.desc, 1111111)
    },
    handleDesc() {
      const _height = this.$refs.desc.clientHeight
      const _readonlyClass = this.readonly ? ' readonly' : ''
      if (_height === 110) {
        //需要展开更多
        this.$refs.desc.className = 'item-msg-con' + _readonlyClass
        this.descfold = true
      } else {
        //收起
        this.$refs.desc.className += ' over'
        this.descfold = false
      }
    },
    //更新里程碑状态
    async handleChangeStatus(val) {
      const param = {
        id: this.id,
        milestone_status: val ? 1 : 0
      }
      const res = await api.changeCrossProjectMilepost(param)
      if (res) {
        this.$message({
          message: '更新里程碑状态成功',
          type: 'success'
        })
        this.$emit('update')
      }
    },
    handleCommand() {
      this.$wfAlert('', '确定删除该里程碑吗？', '', '确定').then(async () => {
        const res = await api.delCrossProjectMilepost({ id: this.id })
        if (res) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.$emit('update')
        }
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })
    },
    handleClose() {
      this.msgFinish = false
      this.form = {
        milestone_name: '',
        end_date: '',
        description: '',
        attachments: []
      }
      if (this.id) {
        //修改状态下，关闭弹窗需更新页面
        this.$emit('update')
      } else {
        this.$emit('handleClose', 'milepostDialogShow')
      }
    },
    async handleAdd() {
      if (!this.form.milestone_name) {
        this.$message({
          message: '请输入标题',
          type: 'warning'
        });
        return
      }
      if (!this.form.end_date) {
        this.$message({
          message: '请选择完成日期',
          type: 'warning'
        });
        return
      }
      const param = {
        milestone_name: this.form.milestone_name,
        // end_date: formatDate(this.form.end_date.getTime()).replaceAll('/', '-'),
        end_date: this.form.end_date.replaceAll('/', '-'),
        description: this.form.description
      }
      param.attachments = this.form.attachments.map((item) => {
        return item.id
      })

      let _api, _msg
      if (this.id) {
        //修改
        param.id = this.form.id
        _api = api.editCrossProjectMilepost
        _msg = '修改里程碑成功'
      } else {
        //新建
        param.cross_project_id = this.crossPojectId
        _api = api.addCrossProjectMilepost
        _msg = '新建里程碑成功'
      }
      const res = await _api(param)
      if (res) {
        if (!this.id) {
          this.$message({
            message: _msg,
            type: 'success'
          })
          this.$emit('update')
        }
      }
    },
    handleAddMilepost(type) {
      // console.log(type,11)
      if (this.readonly) return // 没有更改权限 阻止行为
      this[type] = true
      this.$nextTick(() => {
        this.$refs[type].focus()
      })

    },
    handleInputFocus() {
      this.milepostNameShow = true
    },
    handleChange(val, type) {
      if (!val) return
      this[type] = val
    },
    handleBlur(type) {
      if (type === 'milepostNameShow' && !this.id) {
        // 新建的情况下
        return
      }
        console.log(123)
      this[type] = false
      if (type === 'milepostDescShow') {
        //描述
        this.$refs.desc.className = 'item-msg-con'
        this.$nextTick(() => {
          this.descHandle() //判断描述字数是否超出范围
        })
      }

      if (type === 'milepostNameShow') {
        //标题,为空时不提交更新请求，并变回清空前的数据
        if (!this.form.milestone_name) {
          this.form.milestone_name = this.milestone_name
          return
        }
      }
      if (this.id) {
        this.handleAdd()
      }
    },
    saveData(val, list) {
      this.form.attachments = list
      if (this.id) {
        this.$nextTick(() => {
          this.handleAdd()
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.milepost-dialog-wrap {
  .el-dialog {
    width: 762px;
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      padding: 0 !important;
      .milepost-dialog-top {
        width: 100%;
        padding: 15px 24px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid  rgba(231,232,237,0.6);
        .tit {
          font-size: 16px;
          color: #0D1F3C;
          line-height: 21px;
        }
        .icon-wrap {
          display: flex;
          i {
            font-size: 15px;
            height: 15px;
            padding: 4px;
            border-radius: 4px;
            margin-left: 26px;
            cursor: pointer;
          }
        }
      }
      .milepost-dialog-con {
        width: 100%;
        height: 523px;
        max-height: 523px;
        overflow-y: scroll;
        overflow-x: hidden;
        padding: 16px 24px;
        box-sizing: border-box;
        &.edit-con {
          height: 578px;
          max-height: 578px;
        }
        .con-tit {
          display: flex;
          align-items: center;
          height: 40px;
          font-size: 18px;
          font-weight: 600;
          color: #0D1F3C;
          .el-checkbox {
            margin-right: 8px;
          }
          input {
            font-size: 18px !important;
            font-weight: 600;
            width: 100%;
            height: 40px;
            background: rgba(32, 32, 32, 0.04);
            padding-left: 8px;
            &::-webkit-input-placeholder,
            &::-moz-placeholder {
              font-size: 18px !important;
              font-weight: 400;
              color: rgba(13,31,60,0.4);
            }
          }
          p {
            cursor: pointer;
            flex: 1;
            height: 40px;
            line-height: 40px;
            padding-left: 9px;
            @include ellipsis();
            border-radius: 4px;
            &.readonly {
              pointer-events: none;
            }
            &.complete {
              opacity: .4;
            }
            &:hover {
              background: #f7f8f9;
            }
            &:active {
              background: #eaebec;
            }
          }
        }
        .con-item {
          margin-top: 16px;
          display: flex;
          .item-label {
            width: 112px;
            display: flex;
            line-height: 40px;
            color: rgba(32, 32, 32, 0.6);
            i {
              font-size: 13px;
              line-height: 40px;
              margin-right: 9px;
            }
            p {
              font-size: 14px;
              line-height: 40px;
            }
          }
          .item-msg {
            line-height: 40px;
            flex: 1;
            width: 0;
            .el-input__prefix {
              i {
                line-height: 32px;
              }
            }
            .item-msg-con {
              padding: 0 8px;
              min-height: 40px;
              cursor: pointer;
              border-radius: 4px;
              &.readonly {
                cursor: default;
                &:hover {
                  background: #fff;
                }
              }
              &.item-date {
                width: 110px;
                display: flex;
                align-items: center;
                i {
                  width: 14px;
                  margin-left: 8px;
                  visibility: hidden;
                }
                &:hover {
                  i {
                    visibility: visible;
                  }
                }
              }
              &:hover {
                background: #f7f8f9;
              }
              &:active {
                background: #eaebec;
              }
            }
            // @keyframes descAnimation {
            //   from {
            //     -webkit-transform: rotate(0deg);
            //     transform: rotate(0deg);
            //   }
            //   to {
            //     -webkit-transform: rotate(180deg);
            //     transform: rotate(180deg);
            //   }
            // }
            .desc-wrap {
              padding-top: 9px;
              p {
                line-height: 22px;
              }
              .over {
                max-height: 110px;
                overflow: hidden;
              }
              .check-more {
                padding-left: 8px;
                cursor: pointer;
                color: #2682FF;
                &.descfold {
                  // i {
                  //   animation: descAnimation 0.5s;
                  //   animation-fill-mode: forwards;
                  // }
                }
              }
            }
            .add {
              font-size: 14px;
              line-height: 40px;
              font-weight: 400;
              color: #2682FF;
              cursor: pointer;
              padding-left: 8px;
            }
            .no-content-readonly {
              font-size: 14px;
              color: rgba(32, 32, 32, 0.6);
              padding: 0 8px;
            }
            textarea {
              height: 132px;
            }
            .upload-box {
              line-height: 40px;
              margin-left: 0;
            }
          }
        }
      }
      .btn-wrap {
        width: 100%;
        height: 54px;
        padding: 11px 24px;
        box-sizing: border-box;
        border-top: 1px solid rgba(231,232,237,0.6);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .wf-button {
          width: 76px;
          margin-left: 24px;
        }
      }
    }
  }

}
.milepost-dialog-dropdown {
  .el-dropdown-menu__item {
    color: #FF3939;
    i {
      color: #FF3939;
    }
    &:hover {
      color: #FF3939;
      i {
        color: #FF3939;
      }
    }
    &:active {
      color: #FF3939 !important;
      i {
        color: #FF3939 !important;
      }
    }
  }
}
</style>
